import Dropdown from './_dropdown';
import DropdownMenu from './_dropdown_menu';
import Icon from './_icon';
import VisibilityGroupCreate from './_visibility_group_create';
import VisibilityGroupsManage from './_visibility_groups_manage';
import ManageUsersToolbar from './_manage_users_toolbar';

import {usersGet, userGroupsCountsGet} from '../modules/api/users';
import {userCanCurate, userIsAdmin} from '../modules/roles_utils';
import {renderSuppressionMessage} from '../modules/user_utils.js';
import {DropdownMenuConstants} from '../modules/constants/dropdown_menu';
import {USERS_PER_PAGE} from '../modules/constants/api';

import ReactPaginate from 'react-paginate';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

class ManageUsers extends React.Component {

  static contextTypes = {
    api: PropTypes.object.isRequired,
    utils: PropTypes.object.isRequired
  };

  static propTypes = {
    user: PropTypes.object,
    company: PropTypes.object,
    rivals: PropTypes.arrayOf(PropTypes.object),
    rivalGroups: PropTypes.arrayOf(PropTypes.object),
    userInviteUrl: PropTypes.string
  };

  static defaultProps = {
    user: null,
    company: null,
    rivals: [],
    rivalGroups: [],
    userInviteUrl: ''
  };

  state = {
    filter: '',
    sortOrder: 'alpha',
    viewType: 'consumers', // will be overridden in componentWillMount(), 'consumers' is used here just because it is a shared viewType
    viewGroup: null,
    uiReviewSettingsEnabled: null,
    uiReviewSettingsGroups: null,
    visibilityGroups: [],
    page: 1,
    itemsPerPage: USERS_PER_PAGE,
    users: null,
    countsByViewType: {}
  };

  UNSAFE_componentWillMount() {
    this.setState({
      viewType: userCanCurate({user: this.props.user}) ? 'active' : 'users'
    });
  }

  componentDidMount() {
    console.log('ManageUsers.componentDidMount: props: %o', this.props);

    this.getUsersCounts();

    if(this.context.utils.visibilityGroups) {
      this.setVisibilityGroups();
    }
    else {
      this.context.api.visibilityGroupsGet({code: 'ManageUsers.visibilityGroupsGet'}).then(this.setVisibilityGroups);
    }
  }

  _preventDefault = event => event && event.preventDefault();

  getUsersCounts = () => {
    const {query = '', viewGroup = ''} = this.state;

    const search = {query};

    if(viewGroup) {
      Object.assign(search, {groupFilter: viewGroup});
    }

    userGroupsCountsGet({
      code: 'ManageUsers.userGroupsCountsGet',
      search
    }).then(countsByViewType => {
      this.setState({countsByViewType}, this.loadUsers);
    });
  };

  getPagesCount = () => {
    const {countsByViewType: counters, viewType, viewGroup, itemsPerPage} = this.state;
    let count = 0;

    if(counters) {
      count = counters[viewGroup] ? counters[viewGroup] : counters[viewType] ? counters[viewType] : itemsPerPage;
    }
    else {
      count = itemsPerPage;
    }

    return Math.ceil(count / itemsPerPage);
  };

  setVisibilityGroups = () => {
    const visibilityGroups = [...(this.context.utils.visibilityGroups || [])];

    this.setState({
      visibilityGroups
    });
  };

  handleQueryChange = event => {
    const query = event && event.target ? event.target.value : null;

    this.setState({query}, this.getUsersCounts);
  };

  handleQueryCancel = event => (event && event.which === 27) && this.clearQuery();

  clearQuery = () => {
    if(this.state.query) {
      this.setState({
        query: ''
      }, this.getUsersCounts);
    }
  };

  clearQuery = () => this.state.query && this.setState({
    query: ''
  }, this.getUsersCounts);

  handleRoleChange = (user, addRoles, removeRoles, event) => {
    if(event) {
      event.preventDefault();
    }

    console.log('ManageUsers.handleRoleChange: add=%o: remove=%o for user %o', addRoles, removeRoles, user);

    const userOptions = {
      id: user.id
    };

    if(addRoles) {
      userOptions.addRoles = addRoles;
    }

    if(removeRoles) {
      userOptions.removeRoles = removeRoles;
    }

    this.updateUser(user, userOptions);
  };

  updateUser = (user, userOptions) => {
    if(event) {
      event.preventDefault();
    }

    console.log('ManageUsers.updateUser: user: %o, userOptions: %o', user, userOptions);

    this.context.api.userUpdate(userOptions).then(updatedUser => {
      console.log('ManageUsers.updateUser: updated user: %o', updatedUser);

      // Re-render the current page with updated users data.
      // We need to re-fetch the full page, it's not enough just to update the user's object in current users array
      // E.g. in case of deactivation the user needs to leave the Active users list and another user from down the line needs to be fetched.
      this.loadUsers();
    });
  };

  handleDeleteUser = (user, undo) => {
    const isCurator = userCanCurate({user});
    let confirmMessage = `<strong>${undo ? 'Re-' : 'De'}activate this ${isCurator ? 'curator' : 'user'}?</strong><br /><br />
      You can always undo this later.`;

    if(!undo && isCurator) {
      confirmMessage = `${confirmMessage}<br /><br />Deactivated curators will no longer show up when
        <strong><a href="/settings/profile-curators">assigning profile curators</a></strong>.<br /><br />
        Additionally, if a deactivated curator is reactivated, their original roles and profiles will be re-instated.`;
    }

    const confirmAction = () => {
      const userOptions = {
        id: user.id
      };

      if(undo) {
        userOptions.undo = 'y';
      }

      this.context.api.userDelete(userOptions, updatedUser => {
        if(updatedUser) {
          console.log('ManageUsers.handleDeleteUser: %o user: %o', updatedUser.deletedAt ? 'deactivated' : 're-activated', updatedUser);
        }
        else {
          console.error('ManageUsers.handleDeleteUser: userDelete failed for userOptions: %o', userOptions);
        }

        // Re-render the current page with updated users data.
        // We need to re-fetch the full page, it's not enough just to update the user's object in current users array
        // E.g. in case of deactivation the user needs to leave the Active users list and another user from down the line needs to be fetched.
        this.getUsersCounts();
      });
    };

    this.context.utils.dialog.confirm({
      message: confirmMessage,
      okCallback: confirmAction
    });
  };

  handleResendInvitationClick = user => this.context.api.userReconfirm(user);     // NB: same api as reconfirmation

  handleResendConfirmationClick = user => this.context.api.userReconfirm(user);

  handleViewTypeClick = viewType => this.setState({
    viewType,
    page: 1     // always start with page 1 on view type change
  }, this.loadUsers);

  handleVisibilityGroupClick = viewGroup => {
    const {query} = this.state;

    const search = {groupFilter: viewGroup};

    if(query) {
      Object.assign(search, {query});
    }

    this.setState({viewGroup}, () => {
      userGroupsCountsGet({
        code: 'ManageUsers.userGroupsCountsGet',
        search
      }).then(countsByViewType => {
        this.setState({
          countsByViewType
        }, this.loadUsers);
      });
    });
  };

  handleSortClick = sortOrder => this.setState({
    sortOrder,
    page: 1     // always start with page 1 on sort type change
  }, this.loadUsers);

  handleEmailReviewSettingsClick = user => this.setState({
    uiReviewSettingsEnabled: Boolean(user.emailDigest),
    uiReviewSettingsGroups: this._getEmailReviewFilteredRivalIds(user)
  }, () => {
    this.renderEmailReviewConfigModal(user);
  });

  _getEmailReviewFilteredRivalIds = user => {
    const weeklyReviewData = user.userData ? user.userData.weeklyReviewData : false;

    if(weeklyReviewData && weeklyReviewData.filteredByRivalGroups && !_.isEmpty(weeklyReviewData.filteredByRivalGroups)) {
      return weeklyReviewData.filteredByRivalGroups;
    }

    return false;
  };

  handleCancelEmailReviewSettingsClick = () => this.context.utils.dialog.remove('modal-email-review');

  handleSaveEmailReviewSettingsClick = user => {
    const {uiReviewSettingsEnabled, uiReviewSettingsGroups} = this.state;
    const userData = Object.assign(user.userData, {
      weeklyReviewData: {
        filteredByRivalGroups: uiReviewSettingsGroups
      }
    });

    this.updateUser(user, {
      id: user.id,
      emailDigest: uiReviewSettingsEnabled,
      userData
    });

    this.context.utils.dialog.remove('modal-email-review');
  };

  handleReviewSettingsInput = (stateName, value, isMultiple, user) => {
    const newState = {};
    let val = value;

    if(isMultiple) {
      const options = (this.state[stateName] || []).slice();
      const existingIndex = options.indexOf(value);

      if(existingIndex > -1) {
        options.splice(existingIndex, 1);
      }
      else {
        options.push(value);
      }

      val = options.length ? options : false;
    }

    newState[stateName] = val;

    this.setState(newState, () => {
      this.renderEmailReviewConfigModal(user);
    });
  };

  handleToggleUserDefaultGroup = group => {
    if(_.isEmpty(group)) {
      return;
    }

    const {visibilityGroups: stateVisibilityGroups} = this.state;
    const visibilityGroups = (stateVisibilityGroups || []).map(g => {
      if(g.id === group.id) {
        g.isUserDefault = group.isUserDefault;
      }
      else {
        g.isUserDefault = false;
      }

      return g;
    });

    this.setState({visibilityGroups});
  };

  handleToggleCardDefaultGroup = group => {
    if(_.isEmpty(group)) {
      return;
    }

    const {visibilityGroups: stateVisibilityGroups} = this.state;
    const visibilityGroups = (stateVisibilityGroups || []).map(g => {
      if(g.id === group.id) {
        g.isCardDefault = group.isCardDefault;
      }

      return g;
    });

    this.setState({visibilityGroups});
  };

  renderEmailReviewConfigModal = user => {
    const {rivalGroups} = this.props;
    const {uiReviewSettingsEnabled, uiReviewSettingsGroups} = this.state;
    const {utils: {suppressionNotificationDisabled}} = this.context;
    const uiRivalGroups = [];
    let uiEmptyRivalGroups;
    let uiHelpBlock = (
      <p className="help-block">
        <strong><em>Tip:</em></strong> Curator users can create new company groups on
        the <Link to="/" onClick={() => this.context.utils.dialog.remove('modal-email-review')}><strong>Companies Page</strong></Link>.
      </p>
    );

    for(let i = 0; i < rivalGroups.length; i++) {
      uiRivalGroups.push(
        <div key={i} className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={(uiReviewSettingsGroups || []).includes(rivalGroups[i].id)}
              onChange={e => this.handleReviewSettingsInput('uiReviewSettingsGroups', rivalGroups[i].id, true, user, e)} /> {rivalGroups[i].name}{' '}
            <small style={{opacity: 0.7, whiteSpace: 'nowrap'}}>({rivalGroups[i].rivals.length} Companies)</small>
          </label>
        </div>
      );
    }

    // no companies, empty state message
    if(!rivalGroups || !rivalGroups.length) {
      uiEmptyRivalGroups = (
        <div>
          <div className="help-block">(No company groups exists)</div>
          {uiHelpBlock}
        </div>
      );

      uiHelpBlock = null;
    }

    const uiCompanyFilters = (
      <div className="form-group">
        <label>Company groups to include in {user.firstName}&apos;s Intel Digest:</label>
        {uiHelpBlock}
        <div className="email-review-config-modal--groups">
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                checked={!uiReviewSettingsGroups}
                onChange={e => this.handleReviewSettingsInput('uiReviewSettingsGroups', null, false, user, e)} /> <em>All Companies</em>
            </label>
          </div>
          {uiRivalGroups}
          {uiEmptyRivalGroups}
        </div>
      </div>
    );

    const uiModalContent = (
      <div>
        <h4 className="heading-dialog">Customize <strong>{user.firstName}</strong>&apos;s Intel Digest</h4>
        <div className="u-pt-xs">
          <div className="radio-inline">
            <label>
              <input
                type="radio"
                checked={uiReviewSettingsEnabled}
                onChange={() => this.handleReviewSettingsInput('uiReviewSettingsEnabled', true, false, user)} /> Enabled
            </label>
          </div>
          <div className="radio-inline" style={{marginLeft: '20px'}}>
            <label>
              <input
                type="radio"
                checked={!uiReviewSettingsEnabled}
                onChange={() => this.handleReviewSettingsInput('uiReviewSettingsEnabled', false, false, user)} /> Disabled
            </label>
          </div>
        </div>
        <p className="help-block u-mb-m">
          The <strong>Klue Intel Digest</strong> email includes selected Feed posts.
        </p>
        {uiReviewSettingsEnabled ? uiCompanyFilters : null}
        <div className="row dialog-toolbar">
          <div className="col-sm-5">
            <div className="button button--disabled" onClick={this.handleCancelEmailReviewSettingsClick} style={{width: '100%'}}>Cancel</div>
          </div>
          <div className="col-sm-7">
            <div className="button" onClick={() => this.handleSaveEmailReviewSettingsClick(user)} style={{width: '100%'}}>Save</div>
          </div>
        </div>
      </div>
    );

    this.context.utils.dialog.create({
      id: 'modal-email-review',   // calling with same id with just update the contents
      content: (!suppressionNotificationDisabled() && renderSuppressionMessage(user, this.context.utils.dialog)) || uiModalContent
    });
  };

  renderEmailReviewIndicator = user => {
    const isEnabled = Boolean(user.emailDigest);
    const suppression = user.lastSuppression;
    const rivalFilters = this._getEmailReviewFilteredRivalIds(user);
    const {utils: {suppressionNotificationDisabled}} = this.context;
    const userClass = classNames('email-review-indicator', {
      'email-review-indicator--on': isEnabled,
      'email-review-indicator--configured': rivalFilters,
      'email-review-indicator--off': !suppressionNotificationDisabled() && suppression
    });

    return (
      <div className={userClass} onClick={() => this.handleEmailReviewSettingsClick(user)}>
        <i className="fa fa-envelope" />
      </div>
    );
  };

  onGroupAdded = ({newGroup, dropDownRef, userIdRef}) => {
    const visibilityGroups = [...(this.state.visibilityGroups || []), newGroup];

    this.setState({visibilityGroups}, () => {
      if(userIdRef) {
        this._selectDropdownAndUpdateUser({newGroup, dropDownRef, userIdRef});
      }
      else {
        this.renderVisibilityGroupsModal();
      }
    });
  };

  onGroupUpdated = updatedGroup => {
    const visibilityGroups = (this.state.visibilityGroups || []).map(g => ((g.id === updatedGroup.id) ? updatedGroup : g));

    this.setState({visibilityGroups}, () => this.renderVisibilityGroupsModal());
  };

  onGroupDeleted = groupId => {
    const visibilityGroups = (this.state.visibilityGroups || []).filter(g => g.id !== groupId);

    this.setState({visibilityGroups}, () => this.renderVisibilityGroupsModal());
  };

  onGroupMoved = (groupPositions = []) => {
    const visibilityGroups = [];

    groupPositions.forEach((groupId, index) => {
      const group = (this.state.visibilityGroups || []).find(g => g.id === groupId);

      visibilityGroups.push({
        ...group,
        viewOrder: parseFloat(index)
      });
    });

    this.setState({visibilityGroups}, () => {
      visibilityGroups.forEach(g => {
        const {id, viewOrder} = g;

        this.context.api.visibilityGroupUpdate({
          visibilityGroupOptions: {id, viewOrder}
        });
      });
    });
  };

  _selectDropdownAndUpdateUser = ({newGroup, dropDownRef, userIdRef}) => {
    // Reset the single dropdown state to indicate the changed assignment.
    // Smelly, needs a better way of resetting the child state without resetting the state of parent(which may be expensive with users list).
    this.refs[dropDownRef].getInstance().selectValue(newGroup.id);
    this.updateUserVisibilityGroup({groupId: newGroup.id, userId: userIdRef});
  };

  changeVisibilityGroup = (groupId, options) => {
    const {parentContextId: userId, ref = `visibilityGroupUser${userId}`} = options;

    if(groupId === DropdownMenuConstants.CREATE_NEW_ITEM_REF) {
      const VisibilityGroupCreateDialogId = 'create_visibility_group_modal';
      const dialogBodyContent = (
        <VisibilityGroupCreate
          modalId={VisibilityGroupCreateDialogId}
          dropDownRef={ref}
          userIdRef={userId}
          onGroupAddedCallback={this.onGroupAdded}
          visibilityGroups={this.state.visibilityGroups} />
      );

      this.context.utils.dialog.create({
        id: VisibilityGroupCreateDialogId,
        content: dialogBodyContent,
        _wideMode: true,
        closeOnBgClick: true
      });
    }
    else {
      this.updateUserVisibilityGroup({groupId, userId});
    }
  };

  resetVisibilityGroup = ({parentContextId: userId}) => {
    if(userId) {
      const user = this.state.users.find(u => u.id === userId);
      const userVisibilityGroupId = user.visibilityGroupId;

      user.visibilityGroupId = null;
      this.updateUserVisibilityGroup({groupId: userVisibilityGroupId, userId, remove: true});
    }
  };

  updateUserVisibilityGroup = ({groupId, userId, remove = false}) => {
    if(userId) {
      const users = this.state.users.slice().map(u => {
        if(u.id === userId) {
          u.visibilityGroupId = groupId;
        }

        return u;
      });

      this.setState({users});

      this.context.api.visibilityGroupUpdate({
        visibilityGroupOptions: {
          id: groupId,
          [remove ? 'removeUsers' : 'addUsers']: [userId]
        }
      }).then(this.loadUsers);
    }
  };

  renderVisibilityGroupsModal = () => {
    const manageVisibilityGroupDialogId = 'manage_visibility_group_modal';
    const {visibilityGroups} = this.state;
    const dialogBodyContent = (
      <VisibilityGroupsManage
        modalId={manageVisibilityGroupDialogId}
        visibilityGroups={visibilityGroups}
        onGroupAddedCallback={this.onGroupAdded}
        onGroupUpdatedCallback={this.onGroupUpdated}
        onGroupDeletedCallback={this.onGroupDeleted}
        onGroupMovedCallback={this.onGroupMoved}
        onGroupToggleUserDefault={this.handleToggleUserDefaultGroup}
        onGroupToggleCardDefault={this.handleToggleCardDefaultGroup} />
    );

    this.context.utils.dialog.create({
      id: manageVisibilityGroupDialogId,
      content: dialogBodyContent,
      _widerMode: true
    });
  };

  renderUserList = () => {
    const {user: currentUser} = this.props;
    const {viewType, visibilityGroups, filter, users: currUsers} = this.state;
    const {utils: {assignVisibilityGroupViaSSO, company: {name: currentCompanyName}}} = this.context;
    const users = [...(currUsers || [])];
    const isCurator = userCanCurate({user: currentUser});

    if(this.state.users === null) {
      return (<div className="user-list-loading"><i className="fa fa-spin fa-spinner" /></div>);
    }

    if(!users || !users.length) {
      return (
        <div className="users-empty">
          <p>Sorry, no users matching your search criteria were found.</p>
        </div>
      );
    }

    let userNodes = users.map(user => {
      const userUrl = `/users/${user.id}`;
      const userClass = classNames('user', {
        'user-deleted': Boolean(user.deletedAt),
        'user-pending': Boolean(!user.deletedAt && !user.confirmedAt)
      });
      const userOptions = [];
      let userLabels = (
        <div className="user-labels" />
      );
      let emailDomainRegion;
      let adminLabel;
      let curatorLabel;
      let inactiveLabel;
      let deleteLabel = 'Deactivate';
      let deleteIcon = 'fa-trash';
      let deleteAction;
      let lastSeenAt = (
        <div className="last-seen" />
      );
      let digestRegion = (
        <div className="manage-users-row-email-review-column" />
      );
      let userMenu;
      let visibilityGroupControl;

      // Labels on users: visible to all users
      if(user.deletedAt) {
        inactiveLabel = (
          <span className="label label-flag" title="User is deactivated">Deactivated</span>
        );
      }
      else if(!user.confirmedAt) {
        if(user.pendingInvitation) {
          inactiveLabel = (
            <span className="label label-flag" title="User hasn't accepted invite">Invited</span>
          );
        }
        else {
          inactiveLabel = (
            <span className="label label-flag" title="User hasn't confirmed their email">Unconfirmed</span>
          );
        }
      }

      if(userIsAdmin({user})) {
        adminLabel = (
          <span className="label label-success label-alt">Admin</span>
        );
      }
      else if((user.roles || []).includes('curator')) {
        // NOTE: all admins have curator access, so we don't add a curator label for admins
        curatorLabel = (
          <span className="label label-success">Curator</span>
        );
      }

      // Actions on users: only available to admin users
      if(userIsAdmin({user: currentUser})) {
        const instanceIsNotKlue = currentCompanyName !== 'Klue'; // admin promotions are not allowed in Klue instance

        if(!user.deletedAt) {
          const toAdminAction = e => this.handleRoleChange(user, ['admin'], ['curator'], e);
          const toCuratorAction = e => this.handleRoleChange(user, ['curator'], ['admin'], e);
          const toConsumerAction = e => this.handleRoleChange(user, null, ['admin', 'curator'], e);

          if(adminLabel) {
            userOptions.push({
              value: 'demoteToCurator',
              label: 'Make Curator',
              icon: 'fa-arrow-circle-down',
              onOptionClick: toCuratorAction
            });
            userOptions.push({
              value: 'demoteToConsumer',
              label: 'Make Consumer',
              icon: 'fa-arrow-circle-down',
              onOptionClick: toConsumerAction
            });
          }
          else if(curatorLabel) {
            instanceIsNotKlue && userOptions.push({
              value: 'promoteToAdmin',
              label: 'Make Admin',
              icon: 'fa-arrow-circle-up',
              onOptionClick: toAdminAction
            });
            userOptions.push({
              value: 'demoteToConsumer',
              label: 'Make Consumer',
              icon: 'fa-arrow-circle-down',
              onOptionClick: toConsumerAction
            });
          }
          else {
            instanceIsNotKlue && userOptions.push({
              value: 'promoteToAdmin',
              label: 'Make Admin',
              icon: 'fa-arrow-circle-up',
              onOptionClick: toAdminAction
            });
            userOptions.push({
              value: 'promoteToCurator',
              label: 'Make Curator',
              icon: 'fa-arrow-circle-up',
              onOptionClick: toCuratorAction
            });
          }
        }

        if(!user.deletedAt) {
          deleteAction = () => this.handleDeleteUser(user, false);
        }
        else if(instanceIsNotKlue || !adminLabel) {
          // admins can only be reactivated in instances other than Klue instance (see above)
          deleteLabel = 'Re-activate';
          deleteIcon = 'fa-undo';
          deleteAction = () => this.handleDeleteUser(user, true);
        }

        if(!user.deletedAt) {
          userOptions.push({
            value: 'digest',
            label: 'Customize Intel Digest',
            icon: 'fa-envelope',
            onOptionClick: () => this.handleEmailReviewSettingsClick(user)
          });
        }

        if(!user.deletedAt && this.props.company && this.props.company.passwordAuthEnabled && !user.confirmedAt) {
          if(user.pendingInvitation) {
            userOptions.push({
              value: 'reinvite',
              label: 'Resend Invitation Email',
              icon: 'fa-refresh',
              onOptionClick: () => this.handleResendInvitationClick(user)
            });
          }
          else {
            userOptions.push({
              value: 'reconfirm',
              label: 'Resend Confirmation Email',
              icon: 'fa-refresh',
              onOptionClick: () => this.handleResendConfirmationClick(user)
            });
          }
        }

        if(!inactiveLabel) {
          digestRegion = (
            <div className="manage-users-row-email-review-column">
              {this.renderEmailReviewIndicator(user)}
            </div>
          );
        }
      }

      if(user.lastSeenAt) {
        lastSeenAt = (
          <time className="last-seen" dateTime={user.lastSeenAt} title="Last seen">
            {moment(user.lastSeenAt).fromNow()}
          </time>
        );
      }

      // if deleteAction is set, add it to the end of the menu after separator
      if(deleteAction) {
        userOptions.push({
          value: 'delete',
          label: deleteLabel,
          icon: deleteIcon,
          separator: true,
          onOptionClick: deleteAction
        });
      }

      if(userOptions.length) {
        userMenu = (
          <div className="ui-dropdown-panel">
            <Dropdown
              options={userOptions}
              keyPrefix="user"
              condensed={true} />
          </div>
        );
      }

      if(curatorLabel || adminLabel || inactiveLabel) {
        userLabels = (
          <span className="user-labels">
            {adminLabel || curatorLabel}
            {inactiveLabel}
          </span>
        );
      }

      visibilityGroupControl = (
        <span className="user-visibility-groups--default">{userLabels}</span>
      );

      // check feature flag and show visibility group labels - only visible to curators / admins
      if(isCurator && !curatorLabel && !adminLabel && !inactiveLabel) {
        const visibilityGroupId = (user && user.visibilityGroupId);
        const dropDownValues = [];
        let visibilityGroupName = 'Full Access';

        visibilityGroups.forEach(group => {
          dropDownValues.push([group.id, group.name]);

          if(group.id === visibilityGroupId) {
            visibilityGroupName = group.name;
          }
        });

        dropDownValues.push([
          DropdownMenuConstants.CREATE_NEW_ITEM_REF,
          (<button className="button button--small button--full" key={`createGroup-user${user.id}`}>Create new group</button>),
          true, 'toolbar-dropdown-button--util'
        ]);

        if(visibilityGroupId) {
          dropDownValues.push([
            DropdownMenuConstants.RESET_ITEM_REF,
            (<button className="button button--small button--full button--alert" key={`resetGroup-user${user.id}`}>Reset to Full Access</button>),
            true, 'toolbar-dropdown-button--util'
          ]);
        }

        visibilityGroupControl = (
          <div className="user-visibility-groups">
            {
              assignVisibilityGroupViaSSO() ?
                <span className="current-user-group">{visibilityGroupName}</span> :
                <DropdownMenu
                  id={`visibilityGroupUser${user.id}`}
                  ref={`visibilityGroupUser${user.id}`}
                  values={dropDownValues}
                  selectedValue={visibilityGroupId || 'Full Access'}
                  label=""
                  defaultValue="Full Access"
                  title="Select visibility group"
                  selectCallback={this.changeVisibilityGroup}
                  resetCallback={this.resetVisibilityGroup}
                  parentContextId={user.id} />
            }
          </div>
        );
      }

      if(isCurator) {
        emailDomainRegion = (
          <td>
            <a href={'mailto:' + user.email} className="user-email" title={`Contact ${user.name} (${user.email})`}>{user.email}</a>
          </td>
        );
      }
      else {
        const domain = (user.email || '@').split('@')[1];

        emailDomainRegion = (
          <td>
            {<a href={`https://${domain}`} className="user-email" title={`Visit ${domain}`} target="_blank">{domain}</a>}
          </td>
        );
      }

      return (
        <tr key={user.id} className={userClass}>
          <td>
            <Link to={userUrl} className="user-avatar" title={`View ${user.name}'s profile`}>
              <img src={user.imageMed} alt={user.name} />
            </Link>
          </td>
          <td>
            <Link to={userUrl} className="user-name" title={`View ${user.name}'s profile`}>{user.name}</Link>
          </td>
          <td>
            <span className="user-atname" title={`@${user.username}`}>@{user.username}</span>
          </td>
          {emailDomainRegion}
          <td>
            {visibilityGroupControl}
          </td>
          <td>
            {lastSeenAt}
          </td>
          <td>
            {digestRegion}
          </td>
          <td>
            {userMenu}
          </td>
        </tr>
      );
    });

    if(users.length && !userNodes.length) {
      if((filter || '').trim().length) {
        userNodes = (
          <h4>Sorry, no users matched your search.</h4>
        );
      }
      else {
        const filterLabel = ((viewType === 'all') || (viewType === 'users')) ? '' : viewType;
        const filterRegion = !filterLabel ? null : (
          <strong>{filterLabel}</strong>
        );

        userNodes = (
          <h4>Sorry, no {filterRegion} users were found.</h4>
        );
      }
    }
    else {
      userNodes = (
        <table className="users-table">
          <thead>
            <tr>
              <th colSpan="2">User</th>
              <th>User Name</th>
              {isCurator
                ? <th>Email</th>
                : <th>Domain</th>
              }
              {isCurator
                ? <th>
                  <div className="visibility-group-header">
                    <span className="visibility-group-header--label">Visibility Group</span>
                    <button
                      className="button button--xsmall button--alt visibility-group-header--button"
                      onClick={this.renderVisibilityGroupsModal}>Manage</button>
                  </div>
                </th>
                : <th>Role</th>
              }
              <th colSpan="3">Last Seen</th>
            </tr>
          </thead>
          <tbody>
            {userNodes}
          </tbody>
        </table>
      );
    }

    return userNodes;
  };

  renderSearchRegion = () => {
    const {query = ''} = this.state;
    const searchIconClass = classNames('user-search_form_icon', {
      'user-search_form_icon--active': Boolean(query)
    });
    let searchIconProps = {};

    if(query.length) {
      searchIconProps = {
        onClick: this.clearQuery,
        title: 'Clear search'
      };
    }

    return (
      <form className="user-search_form" onChange={this.handleQueryChange} onKeyDown={this.handleQueryCancel} onSubmit={this._preventDefault}>
        <input ref="filter" type="text" className="klue-input" value={query} placeholder="Find a user..." data-cy="findUserInput" />
        <div className={searchIconClass} {...searchIconProps}>
          <Icon icon={query ? 'close' : 'search'} width="20" height="20" />
        </div>
      </form>
    );
  };

  loadUsers = () => {
    const {page, itemsPerPage: limit, sortOrder: order, viewType: typeFilter, viewGroup: groupFilter, query = ''} = this.state;
    const userOptions = {
      page,
      limit,
      order,
      typeFilter,
      groupFilter,
      deleted: userCanCurate({user: this.props.user}),
      query: (query || '').trim()
    };

    usersGet({userOptions, code: 'ManageUsers.loadUsers'}).then(fetchedUsers => {
      this.setState({
        users: fetchedUsers
      }, () => {
        const {users} = this.state;

        // if there's no users to show and page !== 1, fall back to showing page 1
        // e.g. the last user on the page was deleted, i.e. deactivated from active or reactivated from inactive.
        if((page !== 1) && _.isEmpty(users)) {
          this.setState({
            page: 1
          }, this.getUsersCounts);
        }
      });
    });
  };

  handleChangeItemsPerPage = itemsPerPage => {
    this.setState({itemsPerPage}, this.loadUsers);
  };

  handlePageClick = data => {
    const page = data.selected + 1;

    this.setState({page}, this.loadUsers);
  };

  renderPaginator = () => {
    const pageCount = this.getPagesCount();
    const forcePage = this.state.page ? this.state.page : 1;
    const iconPrevious = (
      <Icon icon="arrow-left" />
    );
    const iconNext = (
      <Icon icon="arrow-right" />
    );

    return pageCount <= 1 ? null : (
      <div className="manage-users-pagination" data-cy="manage-users-pagination">
        <ReactPaginate
          previousLabel={(forcePage !== 1) && iconPrevious}
          nextLabel={(forcePage !== pageCount) && iconNext}
          breakLabel={<span>...</span>}
          breakClassName="break-me"
          forcePage={forcePage - 1}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this.handlePageClick}
          containerClassName="pagination"
          subContainerClassName="pages pagination"
          activeClassName="paginator_active" />
      </div>
    );
  };

  render() {
    const {company, user, userInviteUrl} = this.props;
    const isCurator = userCanCurate({user});
    const {itemsPerPage, visibilityGroups, sortOrder, viewType, viewGroup, countsByViewType} = this.state;
    let inviteRegion;

    if(company && isCurator && (company.passwordAuthEnabled || company.ssoAuthEnabled)) {
      inviteRegion = (
        <div className="user-search_invite">
          <a href={userInviteUrl} className="button">
            Invite New Users
          </a>
        </div>
      );
    }

    return (
      <div className="user-list">
        <ManageUsersToolbar
          user={user}
          sortBy={sortOrder}
          viewBy={viewType}
          viewGroup={viewGroup}
          onSortClick={this.handleSortClick}
          onViewClick={this.handleViewTypeClick}
          onVisibilityGroupClick={this.handleVisibilityGroupClick}
          visibilityGroups={visibilityGroups || []}
          counts={countsByViewType}
          itemsPerPage={itemsPerPage}
          onChangeItemsPerPage={this.handleChangeItemsPerPage} />
        <div className="main">
          <section>
            <h3 className="user-list_heading">
              {viewType === 'users' ? 'All' : viewType} {(viewType !== 'users') && viewType.endsWith('s') ? '' : 'Users'}
            </h3>
            <div className="user-search">
              {this.renderSearchRegion()}
              {inviteRegion}
            </div>
            <div className="table--scroller">
              {this.renderUserList()}
            </div>
            {this.renderPaginator()}
          </section>
        </div>
      </div>
    );
  }

}

export default ManageUsers;
